module.exports = __webpack_public_path__ + "static/media/download.65b4ee8d.svg";